import React, { useEffect } from "react";
import hljs from "highlight.js";
import "highlight.js/styles/github-dark.css"; // Ensure the same theme is used here

const CodeDisplay = ({ code, language }) => {
  useEffect(() => {
    hljs.highlightAll(); // Highlights all code blocks on the page
  }, []);

  return (
    <pre>
      <code className={language}>{code}</code>
    </pre>
  );
};

export default CodeDisplay;
